import React, { useEffect, useState } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import CapacitacionCard from './CapacitacionCard';
import '../styles/Capacitaciones.css';
import '../styles/VerCapacitaciones.css';
import Navbar from './Navbar';
import { useNavigate } from 'react-router-dom';

const API_URL = (process.env.REACT_APP_API_URL || "/").replace(/\/$/, '');

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

const VerCapacitaciones = () => {
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const usuario = JSON.parse(localStorage.getItem('user'));
  const rolUsuario = usuario.IdRol?.toString() || '0';

  useEffect(() => {
    fetch(`${API_URL}/api/capacitaciones/disponibles/${rolUsuario}`, {
      headers: getAuthHeaders()
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) setCategorias(data.data);
        setLoading(false);
      });
  }, [rolUsuario]);

  return (
    <div>
      <Navbar />
      <Container className="py-4">
        <h4 className="mb-3">Capacitaciones disponibles</h4>

        {loading ? (
          <Spinner animation="border" />
        ) : categorias.length === 0 ? (
          <p>No hay capacitaciones disponibles para tu rol.</p>
        ) : (
          <div className="cap-card-grid">
            {categorias.map(cat => (
              <CapacitacionCard
                key={cat.id}
                cat={cat}
                modulosCount={cat.modulos?.length || 0}
                onClick={() => navigate(`/home/modulos/${cat.id}`)}
              />
            ))}
          </div>
        )}
      </Container>
    </div>
  );
};

export default VerCapacitaciones;